import React from 'react';

export interface TooltipRow {
    label: string;
    value: string;
    tone?: 'primary' | 'secondary';
}

interface ChartTooltipProps {
    title: string;
    rows: TooltipRow[];
}

const ChartTooltip: React.FC<ChartTooltipProps> = ({ title, rows }) => (
    <div className="chart-tooltip">
        <p>{title}</p>
        <dl>
            {rows.map((row) => (
                <div key={`${row.label}-${row.value}`}>
                    <dt>
                        {row.tone ? (
                            <i
                                className={`legend-dot legend-dot--${row.tone}`}
                                aria-hidden="true"
                            />
                        ) : null}
                        {row.label}
                    </dt>
                    <dd>{row.value}</dd>
                </div>
            ))}
        </dl>
    </div>
);

export default ChartTooltip;
